import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'serviceos-ng-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
